import React from 'react';
import {
    Heading,
    Icon,
    Surface,
    Text
} from '@/components/ui';
import { Form, FormField } from '@/components/business';

export function NewWidgetType ({ form }) {
    return (
        <div className="tw-max-h-1/4">
            <Form form={form}>
                <FormField name="type"
                    render={({ field }) => (
                        <div className="tw-grid tw-grid-cols-3 tw-grid-rows-2 tw-gap-4">
                            <Surface
                                interactive
                                onClick={() => field.onChange('value_card')}
                                tone="primary"
                            >
                                <div className="tw-relative tw-z-lift tw-flex tw-h-widget-preview tw-w-full tw-flex-col tw-justify-between tw-gap-1">
                                    <div className="tw-flex tw-items-center tw-justify-between">
                                        <Text tone="inherit" variant="control">
                                            {i18next.t('dashboard.custom_dashboard.value_card')}
                                        </Text>
                                        <Icon icon="circleInfo" size="medium" tone="secondary" />
                                    </div>
                                    <div className="tw-flex tw-flex-col tw-items-end">
                                        <Heading as="span" tone="inherit" variant="display">
                                            {i18next.t('dashboard.custom_dashboard.value_placeholder')}
                                        </Heading>
                                        <Text tone="inherit" variant="caption">
                                            {i18next.t('dashboard.custom_dashboard.legend_placeholder')}
                                        </Text>
                                    </div>
                                </div>
                            </Surface>
                            {Array.from({ length: 5 }).map((_, index) => (
                                <Surface key={index} tone="muted">
                                    <Text variant="body">{i18next.t('dashboard.custom_dashboard.coming_soon')}</Text>
                                </Surface>
                            ))}
                        </div>
                    )}
                />
            </Form>
        </div>
    );
}
